import events from "events-bus";
import {useEffect, useState} from "react";
import Constants from "../Constants";

interface TokenEvent {
    token: string
}

const useToken = () => {
    const [token, setToken] = useState<string | null>(null);

    const getToken = () => {
        const frontendAuthorizerConfig = (window as any).frontendAuthorizerConfig;
        if (frontendAuthorizerConfig?.tokenPayload?.customerId) {
            setToken(frontendAuthorizerConfig.token);
        }
    }

    useEffect(() => {
        getToken();

        function tokenListener(eventName: string, data: TokenEvent) {
            const tokenData = data.token;
            setToken(tokenData);
        }

        events.on(Constants.EVENT.AUTH.SUCCESS, tokenListener);

        return () => {
            events.off(tokenListener);
        };
    }, []);

    return {token};
};

export default useToken;
